import { Bonus } from "./Bonus";
import { NoneBonus } from "./NoneBonus";

export class MirrorBonus extends Bonus {

  noEffectWith = [MirrorBonus, NoneBonus];

  constructor () {
    super({
      name: "Miroir",
      value: "mirror",
      icon: "/img/bonus-images/mirror.png",
      description: "Le bonus de ton adversaire se retourne contre lui.",
      timing: "beforeAll",
      isLiveApplied: false,
    });
  }

  apply (team, opponentTeam) {
    if (this.noEffectWith.some(BonusClass => opponentTeam.bonus instanceof BonusClass)) {
      return;
    }

    team.bonus.apply = opponentTeam.bonus.apply;
    team.bonus.timing = opponentTeam.bonus.timing;
    team.bonus.isLiveApplied = false;

    if (opponentTeam.bonus.value === "boostOnePlayer") {
      const targetIndex = opponentTeam.pitchPlayers.findIndex(player => {
        return player.playerId === opponentTeam.bonus.playerId;
      });
      team.bonus.playerId = team.pitchPlayers[targetIndex]?.playerId;
    }

    // On désactive le bonus de l'adversaire
    opponentTeam.bonus = new NoneBonus();
  }
}